/**
 * Preview Origin Configuration
 * 
 * Centralized origin handling for builder ↔ storefront preview communication.
 * Used for iframe src, postMessage targetOrigin, and origin validation.
 */

const DEFAULT_STOREFRONT_ORIGIN = "http://localhost:3000";
const DEFAULT_GRIDA_ORIGIN = "http://localhost:3001";

function normalizeOrigin(raw: string, varName: string): string {
  try {
    return new URL(raw).origin;
  } catch {
    throw new Error(`${varName} must be a valid absolute URL origin`);
  }
}

/**
 * In dev we allow sane localhost defaults for convenience.
 * In production we require explicit env vars to avoid shipping localhost by accident.
 */
function originFromEnv(varName: "VITE_STOREFRONT_ORIGIN" | "VITE_GRIDA_APP_ORIGIN", devDefault: string): string {
  const raw = (import.meta.env as Record<string, unknown>)[varName];
  if (typeof raw === "string" && raw.trim()) {
    return normalizeOrigin(raw.trim(), varName);
  }
  if (import.meta.env.DEV) {
    return normalizeOrigin(devDefault, varName);
  }
  throw new Error(`${varName} environment variable is required`);
}

/**
 * Storefront preview origin (dev default: localhost:3000).
 * Used for iframe src + postMessage targetOrigin validation.
 */
export const STOREFRONT_ORIGIN = originFromEnv("VITE_STOREFRONT_ORIGIN", DEFAULT_STOREFRONT_ORIGIN);

/**
 * Grida editor origin (dev default: localhost:3001).
 */
export const GRIDA_ORIGIN = originFromEnv("VITE_GRIDA_APP_ORIGIN", DEFAULT_GRIDA_ORIGIN);

